<template>
  <div class="all_part">
    <div class="Title_img">
      <img src="../assets/loginLogo.png" alt="" style="width: 300px"/>
    </div>
    <div class="All">
      <div class="all_input">
        <div class="userName">
          <el-input
              v-model="phoneNum"
              placeholder="手机号"
              style="width: 213pt; height: 35.5pt"
              clearable
          ></el-input>
        </div>
        <div class="code_s">
          <div class="password">
            <el-input
                autocomplete="new-password"
                auto-complete="off"
                v-model="Password"
                placeholder="请输入验证码"
                style="width: 149pt; height: 35.5pt"
            ></el-input>
            <div class="code_button">
              <el-button
                  plain
                  type="primary"
                  style="

              "
                  v-on:click="code"
                  :loading="codeStatus"
              >{{ codeStatus ? this.times + "s" : "发送验证码" }}
              </el-button>
            </div>
          </div>
          <div></div>
        </div>
        <div class="all_button">
          <div>
            <el-button
                class="submitButton"
                type="primary"
                style="width: 210pt; height: 38pt;background-color: #8EC31F;border: none ;font-size:16px"
                @click="login"
            >登录
            </el-button>
          </div>
        </div>
      </div>
      <div class="Copyright_information">
        <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
      </div>
    </div>
  </div>
</template>

<script>
import {httpUrl} from "../components/publics";

export default {
  data() {
    return {
      phoneNum: "",
      Password: "",
      userInfo: {},
      codeStatus: false,
      times: "60",
    };
  },
  methods: {
    code() {
      // console.log(this.phoneNum);
      if (this.phoneNum.length == 11) {

        this.axios
            .post(
                httpUrl + "/api/verification/code",
                this.$qs.stringify({
                  phone: this.phoneNum,
                })
            )
            .then((response) => {
              if (response.data.code == 200) {
                this.codeStatus = true;
                let times = setInterval(() => {
                  this.times = this.times - 1;
                  if (this.times <= 0) {
                    this.codeStatus = false;
                    clearInterval(times);
                  }
                }, 1000);
                // this.$message(response.data.message);
                console.log("success", response.data);
              } else {
                this.$message(response.data.message);
              }
            })
            .catch((error) => console.log(error, "error"));
      } else {
        this.$message("请输入正确的手机号");
      }
    },
    login() {
      if (this.phoneNum == "") {
        this.$message("请输入手机号");
        return;
      } else if (this.Password == "") {
        this.$message("请输入验证码");
        return;
      }
      this.axios;
      if (this.phoneNum.length == 11) {
        console.log(this.Password);
        console.log("进来了");
        this.axios
            .post(
                httpUrl + "/api/login/login",
                this.$qs.stringify({
                  phone: this.phoneNum,
                  code: this.Password,
                })
            )
            .then((response) => {
              this.$message(response.data.message);
              if (response.data.code == 200) {
                if (response.data.data.type == 1) {
                  console.log("进来了吗");
                  localStorage.setItem(
                      "user",
                      JSON.stringify(response.data.data)
                  );
                } else {
                  sessionStorage.setItem(
                      "user",
                      JSON.stringify(response.data.data)
                  );
                  setTimeout(() => {
                    localStorage.removeItem("user");
                    sessionStorage.removeItem("user");
                    this.$router.replace("/LoginComputer");
                  }, 43200000);
                }
                this.$router.push("/Main_menuPhone");
              } else {
                sessionStorage.setItem("user", "");
              }
              this.userInfo = response.data.data;
              console.log(this.userInfo);
            })
            .catch((error) => console.log(error, "error"));
      } else {
        this.$message("请输入正确的手机号");
      }
    },
  },
};
</script>

<style>
</style>
<style scoped>
.Login_button >>> .el-button--primary {
  background-image: none!important;
  background-color: #999;
  border-color: #999;
}

.code_button >>> .el-button--primary.is-plain {
  width: 60pt;
  padding: 16px 4px;
  color: #64b252;
  background: #d7ebd3;
  border-color: #aed6a4;
  width: 59.5pt;
  font-size: 10px;
  margin-left: 5px;
  height: 35.5pt;
}

.el-input >>> .el-input__inner {
  height: 35.5pt;
  background: none;
}

.el-input >>> .el-input__inner:focus {
  outline: 0;
}

.all_button >>> .el-button {
  /* border-radius: 25px; */
}

.all_part {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  background-image: url("../assets/Login_img_phone/bg1.png");
}

.All {
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.Title_img {
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.Title_img img {
  width: 100%;
}

.all_input {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.password {
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.all_button {
  display: flex;
  flex-direction: column;
}

.submitButton {
  margin-top: 15px;
}

.code_s {
  display: flex;
  flex-direction: row;
}

.Copyright_information {
  font-size: 7.5pt;
  margin-bottom: 39.5pt;
}
</style>
